/**
 * How long a closed rebate period may stay claimable, as one table svc-promo,
 * the backoffice form and the player card all read.
 *
 * A closed period is claimable until the NEXT period ends, never later: a daily
 * rebate until the end of the following day, a weekly one until the end of the
 * following week, a monthly one until the end of the following month. A longer
 * window would let a member sit on several closed periods at once and cash them
 * in together, which is not what a per-period rebate promises.
 *
 * These are the largest `conditions.claimWindowDays` the save accepts per period
 * mode, and also the window an unset value means. Monthly is 31 because that is
 * the longest a next month can be; the claim path still ends the window at the
 * real end of the next month, so a 31 stored on a period followed by a 30-day
 * month closes a day earlier than 31 days. That calendar step lives with the
 * period arithmetic in svc-promo, not here.
 *
 * No imports on purpose — both SPAs bundle this file.
 */
export const REBATE_CLAIM_WINDOW_MAX_DAYS = {
  daily: 1,
  weekly: 7,
  monthly: 31,
} as const satisfies Record<'daily' | 'weekly' | 'monthly', number>;
